<template>
    <div>
        <default-modal
            ref="box"
            :title="title"
            :modalWidth="600"
            :cancleBtn="true"
            :cancleTxt="`关闭`"
            @confirm="confirm"
        >
            <div class="content">
                <div class="left">
                    选择重启项:
                </div>
                <div class="right">
                    <div>
                        <div class="input">
                            <input type="checkbox" v-model="core" />
                        </div>
                        <div class="_con">
                            <p>核心服务</p>
                            <p>
                                重启该服务时备用远程会短暂中断，约30秒后可重新连接
                            </p>
                        </div>
                    </div>
                    <div>
                        <div class="input">
                            <input type="checkbox" v-model="update" />
                        </div>
                        <div class="_con">
                            <p>服务端与客户端升级服务</p>
                            <p>
                                重启该服务可立即触发版本检测，以获最新版本信息
                            </p>
                        </div>
                    </div>
                    <div>
                        <div class="input">
                            <input type="checkbox" v-model="remote" />
                        </div>
                        <div class="_con">
                            <p>远程控制服务</p>
                            <p>
                                重启该服务时维护大师远控会短暂中断，约30秒后可重新连接
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </default-modal>
    </div>
</template>

<script>
import { sendRemoteCommand } from "@/requests/bar";
import DefaultModal from "_c/modals/defaultModal";
export default {
    name: "barModals",
    components: {
        DefaultModal
    },
    data() {
        return {
            title: "重启产品服务",
            item: {},
            core: false,
            update: false,
            remote: false
        };
    },
    computed: {
        calcCommand() {
            let i = 0;
            if (this.core) {
                i += 1;
            }
            if (this.update) {
                i += 2;
            }
            if (this.remote) {
                i += 4;
            }
            return i;
        }
    },
    mounted() {
        window.$modal.restartServeModal = {};
        window.$modal.restartServeModal.show = item => {
            this.item = item;
            this.init();
        };
    },
    methods: {
        init() {
            this.$refs.box.show();
        },
        async confirm() {
            if (!this.core && !this.update && !this.remote) {
                return this.$refs.box.setWrong("请选择重启服务项");
            }
            let res = await sendRemoteCommand(
                this.item,
                1,
                10005,
                this.calcCommand
            );
            if (res.code == 200) {
                this.$refs.box.hide();
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@import "_style/msgbox/_msgBox.scss";
@import "_style/_color.scss";

.content {
    overflow: hidden;
    padding: 0 20px;
    margin-top: 10px;
    .left {
        float: left;
        padding-right: 10px;
        width: 130px;
        height: 200px;
        text-align: right;
        line-height: 53px;
        color: $gray-word;
    }
    .right {
        overflow: hidden;
        padding-left: 10px;
        .input {
            float: left;
            margin-top: 20px;
            width: 20px;
        }
    }
    ._blue {
        font-size: 14px;
        color: $blue;
        margin-bottom: 20px;
        text-align: left;
    }
    ._con {
        float: left;
        margin-top: 17px;
        width: 390px;
        p {
            line-height: 20px;
            text-align: left;
        }
        p:nth-child(2) {
            color: $gray-word;
        }
    }
    .receiveCode {
        margin: 25px 0 10px 0;
        input {
            width: 300px;
            height: 30px;
            border: 1px solid rgba(230, 230, 230, 1);
            padding-left: 10px;
        }
        a {
            width: 100px;
            height: 30px;
            padding: 0;
            text-align: center;
            line-height: 30px;
            color: #fff;
        }
    }
}
</style>
